<template>
  <q-layout view="lHh Lpr lFf">
    <q-header elevated class="glossy">
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
        />

        <q-toolbar-title>
          Sepet App
        </q-toolbar-title>

        <div>Q v{{ $q.version }}</div>
      </q-toolbar>
    </q-header>

    <q-footer>
      <q-tabs dense>
        <q-route-tab
          v-for="nav in navs"
          :key="nav.label"
          :to="{name: nav.name}"
          :icon="nav.icon"
          exact />
      </q-tabs>
    </q-footer>

    <q-drawer
      v-model="leftDrawerOpen"
      bordered
      content-class="bg-grey-2"
    >
      <q-list>
        <q-item-label header>Menu</q-item-label>
        <q-item clickable 
          tag="a" 
          exact
          :to="{name:'home'}">
          <q-item-section avatar>
            <q-icon name="home" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Inicio</q-item-label>
            <q-item-label caption>inicio logo</q-item-label>
          </q-item-section>
        </q-item>

        <div v-if="isAuthenticated">

          <q-item v-for="item in menu"
            clickable 
            tag="a" 
            exact
            :key="item.label"
            :to="{name:item.name}">

            <q-item-section avatar>
              <q-icon :name="item.icon" />
            </q-item-section>
            <q-item-section>
              <q-item-label>{{item.label}}</q-item-label>
              <q-item-label caption></q-item-label>
            </q-item-section>
          </q-item>

          <q-separator />

          <q-item clickable tag="a" @click="logout">
            <q-item-section avatar>
              <q-icon name="highlight_off" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Logout</q-item-label>
              <q-item-label caption>salir</q-item-label>
            </q-item-section>
          </q-item> 
          <div class="q-pa-sm">
            <div>auth: {{isAuthenticated}}</div>
          </div>
        </div>

      </q-list>
    </q-drawer>

    <q-page-container>
      <keep-alive><router-view/></keep-alive>
    </q-page-container>
  </q-layout>
</template>

<script>
import {userService} from '@/_services/user.service';
import {mapGetters} from 'vuex';

export default {
  name: 'LayoutDefault',

  components: {
    
  },

  data () {
    return {
      // leftDrawerOpen: this.$q.platform.is.desktop,
      leftDrawerOpen: false,
      menu: [
        {
          label: 'Dashboard',
          icon: 'view_list',
          to: 'xx',
          name: 'dashboard',
          caption: 'escritorio'
        },
        {
          label: 'Firma',
          icon: 'view_list',
          to: 'xx',
          name: 'firma',
          caption: 'firma'
        },
        {
          label: 'About',
          icon: 'view_list',
          to: 'xx',
          name: 'about',
          caption: 'about default layout'
        },
        {
          label: 'About 2',
          icon: 'view_list',
          to: 'xx',
          name: 'about2',
          caption: 'layout otro'
        },
        {
          label: 'Flex',
          icon: 'view_list',
          to: 'xx',
          name: 'flexbox',
          caption: 'pruebas'
        }
      ],
      navs: [
          {
            label: 'Inicio',
            icon: 'home',
            to: '/',
            name: 'home'
          },
          {
            label: 'About',
            icon: 'view_list',
            to: '',
            name: 'about'
          }
        ]
    }
  },

  computed: {
    ...mapGetters(['isAuthenticated', 'getToken'])
  },
  methods: {
    // pasar a actions
    logout() {
      userService.logout()
      .then( data => {
        console.log('logout menu layout: ', data);
        this.$store.commit('setUser', {token: ''})
        this.$router.push({name: 'home'});
      })
      
    }
  }
}
</script>

<style lang="sass">
  
</style>
